import { render } from "./Taints.vue?vue&type=template&id=c0310bd8&scoped=true"
import script from "./Taints.vue?vue&type=script&lang=js"
export * from "./Taints.vue?vue&type=script&lang=js"

import "./Taints.vue?vue&type=style&index=0&id=c0310bd8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c0310bd8"]])

export default __exports__